import React, { useEffect, useState } from 'react';

import { Container, Option, Icon } from './styles';

interface Props {
  options: JSX.Element[];
  onChange: (value: number) => void;
  initial?: number;
}

const SwitchIcon = ({ options, onChange, initial = 0 }: Props) => {
  const [selected, setSelected] = useState(initial);

  useEffect(() => {
    setSelected(initial);
  }, [initial]);

  return (
    <Container>
      {options.map((option, idx) => (
        <Option
          key={idx}
          $selected={idx === selected}
          onClick={() => {
            onChange(idx);
          }}
        >
          <Icon>{option}</Icon>
        </Option>
      ))}
    </Container>
  );
};
export default SwitchIcon;
